import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import { mdiInformation } from '@mdi/js';
import AutocompleteGraphql from '@/views/components/autocompletes/AutocompleteGraphql.vue';
import { GET_ASSUNTOS, GET_AUTORES, GET_EDITORAS } from '@/queries';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { cloneDeep } from '@apollo/client/utilities';
import { format, parseISO } from 'date-fns';
import { onKeyDownPreventNonNumbers } from '@/utils/util';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardMaisFiltros',
  setup(__props) {

const store = ConsultaObrasStore();

const { filtroObras, flProducaoCientifica } = storeToRefs(store);

const { setDataPublicacaoInicio, setDataPublicacaoFim } = store;

const dataPublicacaoInicio = computed(() => {
  const dtPublicacaoInicio = cloneDeep(filtroObras.value.dtPublicacaoInicio);
  return dtPublicacaoInicio ? format(parseISO(dtPublicacaoInicio), 'yyyy') : '';
});

const dataPublicacaoFim = computed(() => {
  const dtPublicacaoFim = cloneDeep(filtroObras.value.dtPublicacaoFim);
  return dtPublicacaoFim ? format(parseISO(dtPublicacaoFim), 'yyyy') : '';
});

return { __sfc: true,store, filtroObras, flProducaoCientifica, setDataPublicacaoInicio, setDataPublicacaoFim, dataPublicacaoInicio, dataPublicacaoFim, CardExpand, mdiInformation, AutocompleteGraphql, GET_ASSUNTOS, GET_AUTORES, GET_EDITORAS, onKeyDownPreventNonNumbers }
}

})